import React from "react";
import PredictionPage from "../../components/PredictionPage";

function Corn() {
  return (
    <PredictionPage
      title="Corn"
      content="This is the Corn AI Trading Predictions page."
      canonical="/commodities/corn-ai-trading-predictions"
      categoryKey="nav.commodities"
      categoryPath="/commodities"
      symbol="CORN"
    />
  );
}

export default Corn;
